//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Tooltip,
  Button,
} from '@mui/material';

 import {
  AssignmentTurnedInOutlined,
} from '@mui/icons-material';

// === COMPONENTS ===
import { useTaskComplete } from 'components/useTaskComplete';

// === API ===
import { submitTask } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function SubmitTaskButton() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const completion_status = useTaskComplete();

  const _styles = {
    submit: {
      height : '40px',
      margin: '0 0.5rem',
      backgroundColor: completion_status.is_complete ? theme.palette.success.main : theme.palette.primary.main,
      '&:hover': {
        backgroundColor: completion_status.is_complete ? theme.palette.success.dark : theme.palette.primary.main.dark,
      },
      animation: completion_status.is_complete ? 'pulse 2s infinite' : '',
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title='Submit Task'>
        <Button
          name='submit_task_btn'
          sx={_styles.submit}
          variant='contained'
          color='primary'
          disabled={!completion_status.is_complete}
          component={!completion_status.is_complete ? "div" : undefined}
          onClick={ submitTask }
        >
          <AssignmentTurnedInOutlined />
        </Button>
      </Tooltip>
    );
  };

  //#endregion

  return display();
}
